import React, { Component } from 'react';
import { Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';
import * as moment from 'moment';
import axios from 'axios'
import { base, serverIp, getOrderKey } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'


class MakeOrderLost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lostReason: '',
            lostReasonChoices: [
                { value: 'not_sure', label: 'Not sure about order', category: 'lostReason' },
                { value: 'Deposit_not_paid', label: 'Refused To Pay Desposit', category: 'lostReason' },
                { value: 'no_longer_wants', label: 'Client no longer interested', category: 'lostReason' },
               // { value: 'siniya', label: 'Siniya', category: 'lostReason' },
                { value: 'unable_to_contact', label: 'Unable to Reach Client', category: 'lostReason' },
                { value: 'on_hold', label: 'On Hold', category: 'lostReason' },
                { value: 'Other', label: 'Other', category: 'lostReason' },
            ],
        }
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    makeLost = () => {
        console.log("mk1 ++++++++++++++ makeLost");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.lost,
            lastUpdated: now,
            lastUpdatedBy:this.props.user.email,
            madeLostBy:this.props.user.email
        }

        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

        let updateText = Status.lost+" - "+this.state.lostReason+" - "+this.props.user.email.substring(0,10);
        FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);

        

        let daysSince = Utils.GetDaysSinceOrderPlaced(this.props.order.dateNum);
        let eventProperties = {
            status: this.props.order.status,
            daySinceOrderPlaced: daysSince
        }

        axios.post(serverIp + 'orders/markOrderLostWithReason', {
            apiKey: "PrintB@da7",
            fbOrderKey: this.props.order.key,
            adminEmail: this.props.user.email,
            lostKey:this.state.lostReason
        })
            .then(function (response) {
                console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    render() {

        const lostButton = this.state.lostReason !== ''
            ? <Button onClick={this.makeLost}> MAKE LOST</Button>
            : ''

        const wholeUi = this.props.order.status !== Status.packing
                        && this.props.order.status !== Status.delivered
            ? <div>
                <Divider horizontal>{'LOST!'}</Divider>
                <Select
                    name="form-field-name"
                    value={this.state.lostReason}
                    options={this.state.lostReasonChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                {lostButton}
            </div>
            : ''


        return (
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default MakeOrderLost;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Lost/MakeOrderLost.js